import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NgForm } from '@angular/forms';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { LicenciasService } from '../_services/licencias.service';
import { CentrosDeTrabajoService } from '../_services/centrosdetrabajo.service';
import { EmpresasService } from '../_services/empresas.service';

import { Licencia } from '../_models/licencia.model';

import { AppSettings } from '../_models/settings.models'


import { AsyncAction } from 'rxjs/scheduler/AsyncAction';
import { ConfirmationService } from 'primeng/primeng';
import { UsuariosService } from 'app/_services/usuarios.service';




declare var jQuery: any;

@Component({
    selector: 'licencia',
    templateUrl: 'licencia.template.html'
})
export class LicenciaComponent implements OnInit, OnDestroy, AfterViewInit {

  subscription: Subscription;

  public filterQueryUsuarios = "";

  insertonueva: boolean = false;

  licencia : Licencia;

  fechainicial : Date;
  fechafin : Date;
  editarfecha: boolean = false;
  fechaeditar : Date;
  id_fechaeditar : number = 0;

  es: any;

  listacentros: any = [];
  centrodetrabajoseleccionado : number;

  listaempresas : any = [];

  mostrarmodal: boolean = false;
  mostrarmodaladminusuarioscts: boolean = false;

  listatipos: any = [];

  licenciaCentrosFiltered:any = [];

  listaRoles: any = [];

  constructor(private seguridad: SeguridadService,
      private router: Router,
      private normasService: NormasService,
      private licenciasService: LicenciasService,
      private centrosdetrabajoService: CentrosDeTrabajoService,
      private empresasService: EmpresasService,
      private globalEventsManager: GlobalEventsManager,
      private confirmationService: ConfirmationService,
      private activatedRoute: ActivatedRoute,
      private usuariosService: UsuariosService
      ) {

  }

  ngOnInit() {

    this.es = {
            firstDayOfWeek: 0,
            dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
            dayNamesMin: ["Do","Lu","Ma","Mi","Ju","Vi","Sa"],
            monthNames: [ "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre" ],
            monthNamesShort: [ "Ene", "Feb", "Mar", "Abr", "May", "Jun","Jul", "Ago", "Sep", "Oct", "Nov", "Dic" ]
        };

    this.licencia = new Licencia();

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
        if (mode !== null) {
            if (!mode) {
                this.router.navigate(['login']);
            }
        }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path':'/licencias',
        'name': 'Licencias'
      },
      {
        'path':'#',
        'name': 'Licencia'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    let _id_licencia = this.activatedRoute.snapshot.params["id_licencia"];
    if (_id_licencia && _id_licencia != 0 && _id_licencia != 'nueva' ){
      this.getLicencia(_id_licencia);
    }else{
      this.nuevaLicencia();
    }

    this.getListaRoles();
    this.getListaCentrosDeTrabajo();
    this.getListaEmpresas();
    this.getTiposLicencia();

  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  editarFecha(id_user: number, fecha: string){
    this.editarfecha = true;
    if (fecha != '0000/00/00'){
      this.fechaeditar = new Date(fecha);
    }else{
      this.fechaeditar = null;
    }
    this.id_fechaeditar = id_user;

    setTimeout(() => this.ponerFocoFecha(), 50);

  }

  ponerFocoFecha(){
    jQuery("#fechaeditar_"+this.id_fechaeditar).focus();
  }

  cerrarEditarFecha(){
    this.fechaeditar = null;
    this.editarfecha = false;
    this.id_fechaeditar = 0;
  }

  guardarFecha(id_user: number, id_ct: number, id_licencia: number){

    var fecha_formato = null;
    if (this.fechaeditar){
      fecha_formato = this.fechaeditar.getFullYear() + "/" + (this.fechaeditar.getMonth()+1) + "/" + this.fechaeditar.getDate();
    }
    this.fechaeditar = null;
    this.editarfecha = false;
    this.id_fechaeditar = 0;

    this.setUsuarioLicencia(id_ct,id_user,fecha_formato);

  }

  guardarRole(id_user:number,id_ct:number,id_role:number,id_licencia:number){

    this.setUsuarioRoleCT(id_ct,id_user,id_role,id_licencia);

  }


  borrarFecha(id_user: number, id_ct: number, id_licencia: number){

    this.fechaeditar = null;
    this.editarfecha = false;
    this.id_fechaeditar = 0;

    this.deleteUsuarioLicencia(id_ct,id_user, id_licencia);

  }

  guardar(formulario: NgForm, event: Event){
    this.onSubmit(formulario,event);
  }

  onSubmit(formulario: NgForm, event: Event=null){
    event.preventDefault;

    var fechaini_formato = null;
    if (this.fechainicial){
      fechaini_formato = this.fechainicial.getFullYear() + "/" + (this.fechainicial.getMonth()+1) + "/" + this.fechainicial.getDate();
    }

    var fechafin_formato = null;
    if (this.fechafin){
      fechafin_formato = this.fechafin.getFullYear() + "/" + (this.fechafin.getMonth()+1) + "/" + this.fechafin.getDate();
    }

    let licencia = {
      comentarios: this.licencia.comentarios,
      descripcion: this.licencia.descripcion,
      id_empresa: this.licencia.id_empresa,
      id_licencia: this.licencia.id_licencia,
      id_tipo: this.licencia.id_tipo,
      vigenciafechafin: fechafin_formato,
      vigenciafechainicial: fechaini_formato,
      act: this.licencia.act
    };

    this.licenciasService.setLicencia(licencia).subscribe(
      data => {

        if (data){
          console.log (data.json());

          let al: any = {
            "texto" : "Licencia guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateLicencia(data.json().licencia);
        }

      }
    );

  }

  getTiposLicencia(){
    this.licenciasService.getTiposLicencia().subscribe(
        data => {
          if (data){
            this.listatipos = data.json().lista;
          //  console.log(this.listatipos);
          }
        }
    );
  }

  getLicencia(id_licencia: number){
    this.licenciasService.getLicencia(id_licencia).subscribe(
        data => {
          if (data){
            this.updateLicencia(data.json().licencia);
          }
        }
    );
  }

  getListaCentrosDeTrabajo(){
    this.centrosdetrabajoService.getListaCentrosDeTrabajo().subscribe(
        data => {
          if (data){
            this.listacentros = data.json().lista;
            console.log('lista centros de trabajo');
            console.log(this.listacentros);
          }
        }
    );
  }

  getListaEmpresas(){
    this.empresasService.getListaEmpresas().subscribe(
        data => {
          if (data){
            this.listaempresas = data.json().lista;
          }
        }
    );
  }

  nuevaLicencia(){
    this.insertonueva = true;
    this.licencia.descripcion = "Nueva licencia";
  }

  updateLicencia(data){
    this.cerrarEditarFecha();

    this.fechafin = null;
    this.fechainicial = null ;

    if ((data.id_licencia != this.licencia.id_licencia) && this.licencia.id_licencia == 0){
      this.verLicencia(data.id_licencia);
    }

    this.licencia.id_licencia = data.id_licencia;
    this.licencia.id_empresa = data.id_empresa;
    this.licencia.descripcion = data.descripcion;
    this.licencia.comentarios = data.comentarios;
    this.licencia.centros = data.centros;
    this.licencia.id_tipo = data.id_tipo;
    this.licencia.vigenciafechafin = data.vigenciafechafin;
    this.licencia.vigenciafechainicial = data.vigenciafechainicial;
    this.licencia.act = data.act;

    if (this.licencia.vigenciafechafin){
      this.fechafin = new Date(this.licencia.vigenciafechafin);
    }
    if (this.licencia.vigenciafechainicial){
      this.fechainicial = new Date(this.licencia.vigenciafechainicial);
    }

  }

  asignarUsusario(){
    this.mostrarmodal = true;
  }

  onChangeModal(event){
    this.mostrarmodal = false;

    console.log(event);

    let id_ct = event.id_ct;

    let listausuarios = event.usuarios;

    var fechainicial_formato = null;
    if (this.fechainicial){
      fechainicial_formato = this.fechainicial.getFullYear() + "/" + (this.fechainicial.getMonth()+1) + "/" + this.fechainicial.getDate();
    }

    for (let usuario of listausuarios){
      this.setUsuarioLicencia(id_ct, usuario.id_user, fechainicial_formato);
    }

  }

  //- Cuando cerramos la pantalla modal de administrar usuarios/centros
  onChangeModalAdminUsuariosCts(event){
    this.mostrarmodaladminusuarioscts = false;

    var fechainicial_formato = null;
    if (this.fechainicial){
      fechainicial_formato = this.fechainicial.getFullYear() + "/" + (this.fechainicial.getMonth()+1) + "/" + this.fechainicial.getDate();
    }

    for(let usuario of event.usuarios){
      
      for(let centro of event.centros){
        console.log(usuario.id_user + ' ' + centro.id_ct );
        this.setUsuarioLicencia(centro.id_ct, usuario.id_user, fechainicial_formato);
      }
    }

  }

  setUsuarioLicencia(id_ct: number, id_user: number, fecha: string){

    this.licenciasService.setUsuarioLicencia(this.licencia.id_licencia, id_ct, id_user, fecha).subscribe(
      data => {
        if (data){
          this.getLicencia(this.licencia.id_licencia);
        }
      }
    );

  }

  setUsuarioRoleCT(id_ct: number, id_user: number, id_role: number,id_licencia:number){
    this.licenciasService.setUsuarioRoleCT(this.licencia.id_licencia, id_ct, id_user, id_role).subscribe(
      data => {
        if (data){
          this.getLicencia(this.licencia.id_licencia);
        }
      }
    );
  }

  deleteUsuarioLicencia(id_ct: number, id_user: number, id_licencia: number){

    this.licenciasService.deleteUsuarioLicencia(id_licencia, id_ct, id_user).subscribe(
      data => {
        if (data){
          this.getLicencia(id_licencia);
        }
      }
    );

  }

  comprobarFecha(){
    if (this.fechafin < this.fechainicial && this.fechafin != null){
      this.fechafin = this.fechainicial;
    }
  }

  verLicencia(id_licencia:number){
    this.router.navigate(['licencias',id_licencia]);
  }

  asignarAdminUsusarioCt(){

    this.mostrarmodaladminusuarioscts = true;
  }


  filterUsuarioItems(ev:any){

    let val = ev.target.value;

    if (val && val !== '') {
      this.licenciaCentrosFiltered = this.licencia.centros.filter((item) => {
       return (item.denominacion.toLowerCase().includes(val.toLowerCase()) || item.nombre.toLowerCase().includes(val.toLowerCase()) ||
                item.apellidos.toLowerCase().includes(val.toLowerCase()) || item.nfiscal.toLowerCase().includes(val.toLowerCase()));
     });
     console.log(this.licencia);
     console.log('*****************');
     console.log(this.licenciaCentrosFiltered);
   }else{
     this.getListaCentrosDeTrabajo();
     this.licenciaCentrosFiltered = [];
  
   }
  }

  desasignar(){

    let accion = '';
    
    if (this.licenciaCentrosFiltered.length == 0){
        accion = ' No se ha hecho ninguna selección. Se aplicarán los cambios a la totalidad de usuarios/centros';
        this.licenciaCentrosFiltered = this.licencia.centros;
    //    console.log(this.licencia.centros.length);
      }else{
        accion = ' se aplicarán ' + this.licenciaCentrosFiltered.length + " cambios." ;
      }
      
      
      this.confirmationService.confirm({
        message: 'Está seguro de realizar la acción? ' + accion,
        accept: () => {
          for (let licencia of this.licenciaCentrosFiltered){
            console.log(licencia.id_ct,licencia.id_licencia,licencia.id_user);

            this.borrarFecha(licencia.id_user,licencia.id_ct,licencia.id_licencia);
          }
           },
        reject: () => { 
  
    //      console.log('no hacemos nada');
          this.filterQueryUsuarios = "";
          this.licenciaCentrosFiltered = [];
  
          }
      });

  }

  confirm(texto,valor) {
    
    this.confirmationService.confirm({
      message: texto,
      accept: () => {
        console.log('aceptar');
      }
    });
  }

  getListaRoles() {
    this.usuariosService.getListaRoles().subscribe(
      data => {
        if (data) {
          this.listaRoles = data.json().lista;
          
        }
      }
    );

  }

  onChangeRole(id_user,id_ct,id_role,id_licencia){
    console.log(id_user);
    console.log(id_ct);
    console.log('el role es:' + id_role);
    this.guardarRole(id_user,id_ct,id_role,id_licencia);
  }

}



// WEBPACK FOOTER //
// ./src/app/licencias/licencia.component.ts